<div class="ds-shell" [class.collapsed]="collapsed">

  <!-- Sidebar (drawer on mobile, collapsible rail on desktop) -->
  <div class="ds-aside" [class.open]="drawerOpen">
    <app-dashboard-sidebar [collapsed]="collapsed" (navigate)="closeDrawer()"></app-dashboard-sidebar>
  </div>
  <div class="ds-backdrop" [class.show]="drawerOpen" (click)="closeDrawer()"></div>

  <!-- Main column -->
  <div class="ds-main">

    <header class="ds-topbar">
      <button type="button" class="ds-burger" (click)="onBurger()" aria-label="Toggle menu">
        <i class="fa-solid fa-bars"></i>
      </button>

      <div class="ds-topbar-titles">
        <h1 class="ds-title">{{ pageTitle }}</h1>
        <p class="ds-welcome">
          <span class="dot"></span> Welcome back, <strong>{{ gS.userName || 'there' }}</strong>
        </p>
      </div>

      <div class="ds-topbar-actions">
        <a routerLink="/recharge-wallet" class="ds-recharge">
          <i class="fa-solid fa-wallet"></i>
          <span>Recharge Wallet</span>
          <span class="ds-recharge-amt">{{ gS.currencySign }} {{ gS.userBalance || 0 }}</span>
        </a>

        <div class="ds-profile">
          <button type="button" class="ds-profile-trigger">
            <span class="ds-profile-avatar">{{ initial }}</span>
            <span class="ds-profile-name">My Account</span>
            <i class="fa-solid fa-chevron-down"></i>
          </button>

          <div class="ds-profile-menu">
            <div class="ds-profile-head">
              <span class="ds-profile-head-avatar">{{ initial }}</span>
              <div class="ds-profile-head-info">
                <span class="ds-profile-head-name">{{ gS.userName || 'My Account' }}</span>
                <span class="ds-profile-head-sub">Manage your account</span>
              </div>
            </div>

            <a routerLink="/" class="ds-profile-item">
              <span class="ico"><i class="fa-solid fa-house"></i></span>
              <span class="txt">Home</span>
              <i class="fa-solid fa-chevron-right chev"></i>
            </a>
            <a routerLink="/userdetailPage" class="ds-profile-item">
              <span class="ico"><i class="fa-regular fa-user"></i></span>
              <span class="txt">My Profile</span>
              <i class="fa-solid fa-chevron-right chev"></i>
            </a>
            <a routerLink="/recharge-wallet" class="ds-profile-item">
              <span class="ico"><i class="fa-solid fa-wallet"></i></span>
              <span class="txt">Wallet</span>
              <i class="fa-solid fa-chevron-right chev"></i>
            </a>

            <button type="button" class="ds-profile-item logout" (click)="logout()">
              <span class="ico"><i class="fa-solid fa-right-from-bracket"></i></span>
              <span class="txt">Sign Out</span>
            </button>
          </div>
        </div>
      </div>
    </header>

    <main class="ds-content">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>
